import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, tokenStore } from "./api";

const AuthCtx = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWithToken = (token, u) => {
    tokenStore.set(token);
    setUser(u);
  };

  const setUserFromSession = (u) => {
    setUser(u);
  };

  // Force a re-fetch of the current user from the backend using whatever
  // session cookie / bearer token is now active. Used after popup OAuth so
  // the parent window's state reflects the newly established session.
  const revalidate = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    tokenStore.clear();
    setUser(null);
  };

  return (
    <AuthCtx.Provider
      value={{ user, loading, refresh, revalidate, loginWithToken, setUserFromSession, logout }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
